export default function Footer() {
  const sources = [
    {
      label: "Loominosity · Destiny Oracle / Medicine Shield",
      href: "https://www.loominosity.net/oracle-aka-medicine-shield",
    },
    {
      label: "LD4all · Occult tone formulas",
      href: "https://community.ld4all.com/t/how-to-find-your-occult-tone/13962",
    },
    {
      label: "Mayawisdom · Tzolkin vs. Dreamspell, Leap Day",
      href: "https://www.mayawisdom.com/tzolkin",
    },
    {
      label: "Wikipedia · Dreamspell",
      href: "https://en.wikipedia.org/wiki/Dreamspell",
    },
  ];

  return (
    <footer className="w-full px-4 md:px-6 py-10 md:py-12 border-t border-stone-200">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between gap-8">
          <div>
            <p className="text-sm text-stone-500 leading-relaxed max-w-md">
              © 2026 馬雅圖騰計算器 · 由開源資料整理而成 · 純前端計算，不收集任何個人資料。
            </p>
          </div>
          <div>
            <div className="text-xs font-semibold text-stone-600 uppercase tracking-wider mb-3">
              來源 / Sources
            </div>
            <ul className="space-y-1.5">
              {sources.map((s, i) => (
                <li key={i}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-stone-500 hover:text-stone-800 transition-colors underline underline-offset-2"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}